import ReactDOM from "react-dom";
import { Footer } from "../../shared/footer.js";
import { Navbar } from "../../shared/navbar.js";
import React from "react";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
import "./main.css";
import "../../../../shared/styles/linkStyles.css";
import "../../../../shared/styles/buttonStyles.css";
function Container() {
    return (React.createElement("div", null,
        React.createElement(Navbar, null),
        React.createElement("main", { className: "contact-site-container landing-page-main" },
            React.createElement("section", { className: "contact-site-main-section" },
                React.createElement("h2", null, "Kontakt:"),
                React.createElement("div", null, "Adres e-mail: kontakt@fhub.pl"))),
        React.createElement(Footer, null)));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(Container(), document.body.querySelector("#container"));
